import { graphql } from '@contra/relay';

export const DeauthenticateUser = graphql`
  mutation DeauthenticateUserMutation {
    deauthenticate {
      visitor {
        ...AppPreload_visitor
        userAccount {
          id @deleteRecord
        }
      }
      deauthenticated
      errors {
        message
      }
    }
  }
`;
